<template>
  <div class="device-selection">
    <el-select
      class="language-selection"
      v-model="activeLanguage"
      popper-class="device__sub-select language"
    >
      <el-option
        v-for="(item, idx) in langOptions"
        :key="idx"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { store as localStorage } from '@/utils/common';

export default {
  computed: {
    ...mapState('userOtherSetting', ['language']),

    langOptions() {
      return [
        {
          label: this.$t(`sideMenu.langSettings.ja`),
          value: 'ja'
        },
        {
          label: this.$t(`sideMenu.langSettings.en`),
          value: 'en'
        }
      ];
    },

    activeLanguage: {
      get: function () {
        return this.language;
      },
      set: function (newValue) {
        localStorage.setLang(newValue);
        this.switchLanguage(newValue);
      }
    }
  },
  methods: {
    ...mapMutations('userOtherSetting', ['setLanguage']),

    switchLanguage(lang) {
      this.$i18n.locale = lang;
      this.setLanguage(lang);
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/device_selection.css"></style>
<style scoped src="@/assets/css/pc/side_menu.css"></style>
